import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export function safeFormatDate(
  date: Date | string | null | undefined | any,
  formatString: string,
  timezone: string = 'America/New_York'
): string {
  if (!date) return 'N/A';
  
  try {
    let dateObj: Date;
    
    // Handle Firestore Timestamp objects
    if (date && typeof date === 'object' && 'toDate' in date) {
      dateObj = date.toDate();
    } else if (date instanceof Date) {
      dateObj = date;
    } else {
      dateObj = new Date(date);
    }
    
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      console.warn('Invalid date value:', date);
      return 'Invalid date';
    }
    
    const zonedDate = toZonedTime(dateObj, timezone);
    return format(zonedDate, formatString);
  } catch (error) {
    console.error('Error formatting date:', error, 'Date value:', date);
    return 'Error formatting date';
  }
}

export function isValidDate(date: any): boolean {
  if (!date) return false;
  const dateObj = date instanceof Date ? date : new Date(date);
  return !isNaN(dateObj.getTime());
}